import React from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import HeadContainer from '../../../common/head-container';

const ErrorPage404 = ({ setScreenNumber, onTelegramHandleClick }) => {
  return (
    <div
      className={styles.container}
      style={{
        backgroundImage: `url("${getImageFromS3('images/ua-hostess/bg.png')}")`
      }}
    >
      <div className={styles.headContainer}>
        <HeadContainer
          setScreenNumber={setScreenNumber}
          onTelegramHandleClick={onTelegramHandleClick}
          telegramOnly
        />
      </div>
      <div className={styles.content}>
        <p className={styles.title}>404</p>
        <p className={styles.description}>
          Упс...<br></br>
          Такої сторінки не існує.
        </p>
      </div>
    </div>
  );
};

export default ErrorPage404;
